import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { OutTimeRenderer } from 'timeSheet/components/CellRenderers';

const useOutColumn = ({
  updateEndTime,
  hasActionPermission,
  setIsPromptOpen,
  updateOSEndTime,
  allowUpdateExternal = false
}) => {
  const { t, timeFormat } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return OutTimeRenderer({
        rowData: params.data,
        columnData: {
          updateEndTime,
          updateOSEndTime: allowUpdateExternal ? updateOSEndTime : undefined,
          readOnly: !hasActionPermission,
          onOutsideClickSave: true,
          showClientTimesheetOriginalHours: true,
          allowUpdateExternal,
          setIsPromptOpen,
          timeFormat
        }
      });
    },
    [updateEndTime, updateOSEndTime, hasActionPermission, allowUpdateExternal, setIsPromptOpen, timeFormat]
  );

  return useMemo(
    () => ({
      field: 'actualOut',
      headerName: t('out'),
      cellClass: 'justify-start',
      width: 125,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useOutColumn;
